import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  howToLink: {
    margin: '0 auto',
  },
}));
